import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import Selector from "pages/_components/fields/formik/Selector";
import TextField from "pages/_components/fields/TextField";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FORM_ID, transmissionTypes, beneficiaryTypes } from "util/creditBills";
import * as i18n from "util/i18n";
import BillInfoSummary from "../components/BillsInfoSummary";
import ActionBillTable from "../components/Table";
import { useTransmitForm } from "../hooks/useTransmitForm";

const TransmitFCEMPage = ({ isDesktop }) => {
    const {
        handleSubmit,
        tabOption,
        initialValues,
        validationSchema,
        bills,
        npfcOptions,
        fetching,
    } = useTransmitForm();
    const placeholder = i18n.get("global.select");
    const hasMoreThan1Bill = bills?.length > 1;
    const beneficiaryTypeOptions = i18n.formatOption(beneficiaryTypes, "creditBill.beneficiary.type");
    const transmissionTypeOptions = i18n
        .formatOption(transmissionTypes, "creditBill.transmit.type")
        .filter((item) => item.value !== "NEG");

    const handleBeneficiary = (value, setFieldValue) => {
        const companyName = npfcOptions.find((item) => item.value === value).label;
        setFieldValue("beneficiaryCompanyName", companyName);
    };

    return (
        <>
            <Notification scopeToShow="transmitFCEMPage" />
            <ResponsiveHeader id="creditBill.transmit" showLabel />
            <MainContainer showLoader={fetching} className={isDesktop ? "credit-bills" : "credit-bills"}>
                <ActionBillTable isDesktop={isDesktop} tabOption={tabOption} bills={bills} />
                {hasMoreThan1Bill && <BillInfoSummary bills={bills} isDesktop={isDesktop} />}
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}>
                    {({ values, setFieldValue }) => {
                        const canSubmit =
                            !values.cuit ||
                            !values.beneficiaryCompanyName ||
                            !values.transmissionType ||
                            !values.motive;
                        const isNominal = values.transmissionType === "NOM";
                        return (
                            <Form>
                                <GridTable className={isDesktop ? "fce-transmit-type fce-list" : "fce-transmit-type"}>
                                    <GridTable.Container>
                                        <GridTable.Data>
                                            <Field
                                                component={Selector}
                                                idForm={FORM_ID}
                                                name="transmissionType"
                                                options={transmissionTypeOptions}
                                                placeholder={placeholder}
                                                disabled
                                            />
                                        </GridTable.Data>
                                        {isNominal && (
                                            <>
                                                <GridTable.Data>
                                                    <Field
                                                        component={Selector}
                                                        idForm={FORM_ID}
                                                        name="beneficiaryType"
                                                        options={beneficiaryTypeOptions}
                                                        placeholder={placeholder}
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data>
                                                    <Field
                                                        component={Selector}
                                                        idForm={FORM_ID}
                                                        name="cuit"
                                                        options={npfcOptions}
                                                        placeholder={placeholder}
                                                        onChange={(option) => handleBeneficiary(option, setFieldValue)}
                                                        searchable
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data>
                                                    <Field
                                                        component={TextField}
                                                        labelnoI18n={i18n.get("creditBill.transmission.motive.label")}
                                                        placeholderText={i18n.get("creditBill.motive.placeholder")}
                                                        name="motive"
                                                        type="text"
                                                        maxLength="150"
                                                    />
                                                </GridTable.Data>
                                            </>
                                        )}
                                    </GridTable.Container>
                                </GridTable>

                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={canSubmit}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </MainContainer>
        </>
    );
};

TransmitFCEMPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransmitFCEMPage;
